import { createContext, useContext } from 'react'
import { MainBorrowerPricingAction, MainBorrowerPricingAsyncActions, MainBorrowerPricingSyncActions } from './actions/types'
import { MainBorrowerPricingState } from './types'

export interface MainBorrowerPricingContextProps extends MainBorrowerPricingSyncActions, MainBorrowerPricingAsyncActions {
  state: MainBorrowerPricingState
  dispatch: React.Dispatch<MainBorrowerPricingAction>
}

export const MainBorrowerPricingContext = createContext<MainBorrowerPricingContextProps | undefined>(undefined)

export const useMainBorrowerPricing = () => {
  const context = useContext(MainBorrowerPricingContext)
  if (context === undefined) {
    throw new Error('useMainBorrowerPricing must be used within a MainBorrowerPricingProvider')
  }
  return context
}

export const useMainBorrowerPricingActions = () => {
  const context = useContext(MainBorrowerPricingContext)
  if (context === undefined) {
    throw new Error('useMainBorrowerPricingActions must be used within a MainBorrowerPricingProvider')
  }

  const {
    state,
    dispatch,
    ...actions
  } = context

  return actions
}

export const useMainBorrowerPricingState = () => {
  const context = useContext(MainBorrowerPricingContext)
  if (context === undefined) {
    throw new Error('useMainBorrowerPricingState must be used within a MainBorrowerPricingProvider')
  }

  return context.state
}
